export default __webpack_public_path__ + "static/media/pm-logo-white.63d05c01.svg";